import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

export const prepareCampaignItem = data => {
  const type = [];

  if (!data.type) {
    const hasLinks = data.bonuses && data.bonuses.length > 0;
    const hasBoost = (data.commission_rate_multipliers && data.commission_rate_multipliers.length > 0) || (data.minimum_commission_rates && data.minimum_commission_rates.length > 0);
    const hasGMV = data.gmv_modifiers && data.gmv_modifiers.length > 0;
    if (hasLinks) {
      type.push('Links');
    }
    if (hasBoost) {
      type.push((hasLinks || hasGMV) ? 'Boost' : 'Boost commission');
    }
    if (hasGMV) {
      type.push('GMV');
    }
  }

  return {
    key: data.id,
    id: data.id,
    title: { id: data.id, name: data.name, description: data.description },
    date: { date_start: data.date_start, date_end: data.date_end },
    type: data.type ? data.type : type.join(' + '),
    users: { count: data.total_users, list: data.top_users },

    name: data.name,
    status: data.status,
    user_group_type: data.user_group_type,
    group_instance_id: data.group_instance_id,
    user_group_join_type: data.user_group_join_type,
    commission_rate_multipliers: data.commission_rate_multipliers,
    minimum_commission_rates: data.minimum_commission_rates,
    bonuses: data.bonuses,
    gmv_modifiers: data.gmv_modifiers,
    operations: data
  };
};

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = prepareCampaignItem(item);
    dataTable.push(el);
  });

  return dataTable;
};

function* getAssignments({ payload: { signal, searchQ, curr_page, status } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.modifiers.assignments.list,
      params: {
        page: curr_page,
        q: searchQ,
        ...(status ? { status } : {})
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getAssignmentsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getAssignmentsFailed,
      endpoint: api.modifiers.assignments.list.url
    });
  }
}

export const getAssignmentsSaga = takeEvery(types.GET_ASSIGNMENTS_REQUEST, getAssignments);